import type {Reducer} from 'redux';
import type {Account, AuthedUserAccount} from 'src/types/account';
import type {AccountsAction, AccountMerge} from 'src/action-creators/accounts';

import omit from 'lodash/omit';

import {
  RECEIVE,
  MERGE_ACCOUNT,
  RECEIVE_AUTHED_USER,
  RECEIVE_AUTHED_USER_PHONE,
  INPUT_AUTHED_USER_PHONE,
  REMOVE_ACCOUNT,
  SET_CONFIRMATION_MESSAGE,
  SET_AUTHED,
} from 'src/action-creators/accounts';

// @ts-expect-error - TS7006 - Parameter 'arg' implicitly has an 'any' type.
const notNullOrUndefined = (arg) => arg !== null && arg !== undefined;

const mergeAccounts = (
  data: AccountsById,
  accountsArg: AuthedUserAccount | Account | AccountMerge | Account[],
): AccountsById => {
  const accounts = Array.isArray(accountsArg) ? accountsArg : [accountsArg];
  return accounts.filter(notNullOrUndefined).reduce<AccountsById>(
    (byId, account) => {
      // @ts-expect-error - TS2322 - Type '{ id: string; name: string; firstName?: string | undefined; lastName?: string | undefined; salesforceContactId?: string | undefined; timeCreated?: string | undefined; email: string; ... 4 more ...; profilePicture?: { ...; } | undefined; } | ... 4 more ... | { ...; }' is not assignable to type 'Account | AuthedUserAccount'.
      byId[account.id] = {
        ...byId[account.id],
        ...account,
      };
      return byId;
    },
    {...data},
  );
};

export type AccountsById = {
  [id: string]: Account | AuthedUserAccount;
};

export type State = {
  data: AccountsById;
  isAuthed: boolean;
  authedUserId: string | null | undefined;
  authedUserPhone: string | null | undefined;
  authedUserPhoneError: string | null | undefined;
  authedUserPhoneFormInput: string;
  postAuthPath: string | null | undefined;
  confirmationMessage: string;
};

const initialState: State = {
  data: Object.freeze({}),
  isAuthed: false,
  authedUserId: null,
  authedUserPhone: null,
  authedUserPhoneError: null,
  authedUserPhoneFormInput: '',
  postAuthPath: null,
  confirmationMessage: '',
};

const reducer: Reducer<State, AccountsAction> = (
  state: State = initialState,
  action: AccountsAction,
): State => {
  switch (action.type) {
    case RECEIVE:
    case MERGE_ACCOUNT:
      return {
        ...state,
        data: mergeAccounts(state.data, action.payload),
      };

    case RECEIVE_AUTHED_USER:
      return {
        ...state,
        data: mergeAccounts(state.data, action.payload),
        authedUserId: action.payload.id,
        isAuthed: true,
      };

    case RECEIVE_AUTHED_USER_PHONE:
      return {
        ...state,
        authedUserPhone: action.payload,
        authedUserPhoneError: action.error ? action.payload : null,
      };

    case INPUT_AUTHED_USER_PHONE:
      return {
        ...state,
        authedUserPhoneFormInput: action.payload,
      };

    case REMOVE_ACCOUNT:
      return {
        ...state,
        data: omit(state.data, action.payload),
      };

    case SET_CONFIRMATION_MESSAGE:
      return {
        ...state,
        confirmationMessage: action.payload,
      };

    case 'accounts/setPostAuthPath':
      return {
        ...state,
        postAuthPath: action.payload,
      };

    case SET_AUTHED:
      return {
        ...state,
        isAuthed: action.payload,
      };
  }

  return state;
};
export default reducer;
